import { render } from "./Item6.vue?vue&type=template&id=2b9799c2&ts=true"
import script from "./Item6.vue?vue&type=script&lang=ts"
export * from "./Item6.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__